var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormItem',[_c('Checkbox',{attrs:{"size":"large"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_vm._v(_vm._s(_vm.content)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }